import LoginScreenImage from "../assets/Login_Screen.png";
import APICredentialsImage from "../assets/ApiCredentials.png";
import IntegrateScreenImage from "../assets/IntegrateScreen.png";
import ZohoAuthImage from "../assets/ZohoAuth.png";
import MapUsersScreen from "../assets/MapUsers.png";
import MapUserPopup from "../assets/MapUserPopup.png";
import MappedUserList from "../assets/MappedUserList.png";
import LeadsGreen from "../assets/LeadsGreen.png";
import CallPopup from "../assets/CallPopup.png";

const UserGuide = () => {
  return (
    <div className="user-guide-container">
      {/* <h1 className="title">
        Jas Communications - Zoho PhoneBridge Integration Guide
      </h1> */}

      <section>
        {/* <h2>🧩 User Guide Documentation</h2> */}

        <h3>1. User Authentication</h3>
        <ol>
          <li>
            Login securely as an Admin with JAS Communications credentials.{" "}
            <a href="#login">Login</a>
          </li>
          <img
            src={LoginScreenImage}
            alt="Login screen with authentication UI"
            loading="lazy"
          />
          <li>
            Enter your JAS API credentials (Client ID & Secret). If you don’t
            have them, contact the support team.
          </li>
          <img
            src={APICredentialsImage}
            alt="API credentials input screen"
            loading="lazy"
          />
        </ol>

        <h3>2. Zoho Account Integration</h3>
        <ol>
          <li>
            After successful login, click the "Integrate" button to begin Zoho
            integration.
          </li>
          <img
            src={IntegrateScreenImage}
            alt="Integrate with Zoho screen"
            loading="lazy"
          />
          <li>Authenticate your Zoho account using the OAuth 2.0 flow.</li>
          <img
            src={ZohoAuthImage}
            alt="Zoho account authentication screen"
            loading="lazy"
          />
          <li>
            After authorization, the system will fetch Zoho CRM users
            automatically.
          </li>
        </ol>

        <h3>3. User-DN Mapping</h3>
        <ol>
          <li>
            Once integrated, click the "Integrate User To Zoho" button to map DN
            (phone numbers) to Zoho users.
          </li>
          <img
            src={MapUsersScreen}
            alt="User mapping interface"
            loading="lazy"
          />
          <li>In the popup, select a Zoho user and the DN to map.</li>
          <img
            src={MapUserPopup}
            alt="Mapping popup showing Zoho users and DNs"
            loading="lazy"
          />
          <li>
            The mapped users will be listed and can be disabled anytime if
            needed.
          </li>
          <img src={MappedUserList} alt="List of mapped users" loading="lazy" />
        </ol>

        <h3>4. Click-to-Dial Activation</h3>
        <ol>
          <li>
            Once mapped, users will have PhoneBridge enabled (indicated by a
            green call icon).
          </li>
          <img
            src={LeadsGreen}
            alt="Leads list showing green call icon"
            loading="lazy"
          />
          <li>
            Users can now initiate calls directly from Zoho CRM, with a popup to
            add call notes.
          </li>
          <img
            src={CallPopup}
            alt="Call popup to enter notes after dialing"
            loading="lazy"
          />
        </ol>
      </section>
    </div>
  );
};

export default UserGuide;
